import { Component, EventEmitter, Input, Optional, Output } from '@angular/core'
import { ControlContainer, NgForm } from '@angular/forms'
import { SelectionData } from '@evologi/shared/data-access-api'

export type ButtonsGroupValue =
  | string
  | string[]
  | number
  | boolean
  | object
  | { [key: string]: boolean }

@Component({
  selector: 'op-buttons-group-ng',
  templateUrl: './buttons-group-ng.component.html',
  styleUrls: ['./buttons-group-ng.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      deps: [[Optional, NgForm]],
      useFactory: (ngForm: NgForm) => ngForm,
    },
  ],
})
export class ButtonsGroupNgComponent {
  @Input() items?: SelectionData<string | number | boolean>[]
  @Input() key?: string
  @Input() value?: ButtonsGroupValue
  @Input() class?: string
  @Input() required = false
  @Input() detached = false
  @Input() disabled = false
  @Input() type: 'radio' | 'checkbox' = 'radio'
  @Input() expanded = false
  @Input() isBoolean = false

  @Output() readonly valueChange = new EventEmitter<ButtonsGroupValue>()
}
